/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import MDModal from "@mui/material/Modal";
import { FC } from "react";
import { ModalOwnProps } from "@mui/base";
import Box from "./Box";

/**
 * Props for Modal component with size constraints.
 */
export interface ModalProps extends ModalOwnProps {
  maxWidth?: string;
  minWidth?: string;
}

/**
 * Custom modal dialog component with enhanced accessibility and styling.
 * 
 * Features:
 * - Backdrop with semi-transparent overlay
 * - Prevents scroll lock on body
 * - Disables escape key close for data retention
 * - Prevents auto-focus and focus trapping
 * - Configurable width constraints (min/max)
 * - Accessible with ARIA labels
 * - Proper pointer events handling to prevent click-through
 * 
 * Used throughout the application for forms, confirmations, and data viewers.
 * 
 * @param props - Modal properties including open, onClose, children
 * @returns Accessible modal dialog component
 */
export const Modal: FC<ModalProps> = (props) => {
  return (
    <div>
      <MDModal
        className="modal-container"
        disableScrollLock={false}
        disableEscapeKeyDown={true}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        {...props}
      >
        <Box 
          className="data-view card-general-content"
          style={{ 
            minWidth: props.minWidth,
            maxWidth: props.maxWidth
          }}
        >
          {props.children}
        </Box>
      </MDModal>
    </div>
  );
};